import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function BluetoothPage({ theme }) {
  var navigate = useNavigate();
  var isDark = theme === 'dark';

  // 双设备状态 — 从localStorage恢复
  var [qingnanStatus, setQingnanStatus] = useState(function() { return localStorage.getItem('bt_qingnan') || 'disconnected'; });
  var [funfStatus, setFunfStatus] = useState(function() { return localStorage.getItem('bt_funf') || 'disconnected'; });
  var [qingnanBattery, setQingnanBattery] = useState(null);
  var [funfBattery, setFunfBattery] = useState(null);
  var [remoteDevice, setRemoteDevice] = useState(null);

  // 状态变化时持久化到localStorage
  useEffect(function() { localStorage.setItem('bt_qingnan', qingnanStatus); }, [qingnanStatus]);
  useEffect(function() { localStorage.setItem('bt_funf', funfStatus); }, [funfStatus]);

  var bg = isDark ? '#0d0d1a' : '#1a1a2e';
  var cardBg = isDark ? '#1a1a2e' : '#242440';
  var accent = '#c4956a';

  var sendBT = function(cmd) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeAction) {
      window.webkit.messageHandlers.nativeAction.postMessage(cmd);
    } else {
      console.log('BT command (no native):', JSON.stringify(cmd));
    }
  };

  // 连接指定设备
  var handleConnect = function(device) {
    if (device === 'qingnan') setQingnanStatus('scanning');
    if (device === 'funf') setFunfStatus('scanning');
    sendBT({ action: 'bt_control', command: 'connect', device: device });
  };

  // 断开指定设备
  var handleDisconnect = function(device) {
    var stopCmd = device === 'funf' ? 'funf_stop' : 'stop';
    sendBT({ action: 'bt_control', command: stopCmd, device: device });
    setTimeout(function() {
      sendBT({ action: 'bt_control', command: 'disconnect', device: device });
      if (device === 'qingnan') setQingnanStatus('disconnected');
      if (device === 'funf') setFunfStatus('disconnected');
    }, 300);
  };

  // 全部停止
  var handleStopAll = function() {
    sendBT({ action: 'bt_control', command: 'stop' });
    sendBT({ action: 'bt_control', command: 'funf_stop', device: 'funf' });
  };

  // 轮询native层蓝牙状态
  useEffect(function() {
    var timer = setInterval(function() {
      if (window.btStatus) {
        // 新版多设备格式
        if (window.btStatus.qingnan) {
          if (window.btStatus.qingnan.connected) {
            setQingnanStatus('connected');
            if (window.btStatus.qingnan.battery) setQingnanBattery(window.btStatus.qingnan.battery);
          } else if (qingnanStatus === 'connected') {
            setQingnanStatus('disconnected');
          }
        }
        if (window.btStatus.funf) {
          if (window.btStatus.funf.connected) {
            setFunfStatus('connected');
            if (window.btStatus.funf.battery) setFunfBattery(window.btStatus.funf.battery);
          } else if (funfStatus === 'connected') {
            setFunfStatus('disconnected');
          }
        }
        // 兼容旧版单设备格式
        if (!window.btStatus.qingnan && window.btStatus.connected !== undefined) {
          if (window.btStatus.connected) {
            setQingnanStatus('connected');
            if (window.btStatus.battery) setQingnanBattery(window.btStatus.battery);
          } else if (qingnanStatus === 'connected') {
            setQingnanStatus('disconnected');
          }
        }
      }
    }, 1000);
    return function() { clearInterval(timer); };
  }, [qingnanStatus, funfStatus]);

  // 监听远程控制事件
  useEffect(function() {
    var handler = function(e) {
      if (e.detail && e.detail.action === 'bt_control') {
        var dev = e.detail.device || 'qingnan';
        setRemoteDevice(dev);
        setTimeout(function() { setRemoteDevice(null); }, 3000);
      }
    };
    window.addEventListener('bt_remote', handler);
    return function() { window.removeEventListener('bt_remote', handler); };
  }, []);

  var anyConnected = qingnanStatus === 'connected' || funfStatus === 'connected';

  // 蓝牙图标SVG
  var btIcon = function(color, size) {
    return (
      <svg width={size || 28} height={size || 28} viewBox="0 0 24 24" fill="none" stroke={color || '#555'} strokeWidth="1.5">
        <path d="M6.5 6.5l11 11M17.5 6.5l-11 11M12 2v20M7 7l5-5 5 5M7 17l5 5 5-5" />
      </svg>
    );
  };

  // 单个设备卡片
  var DeviceCard = function({ name, displayName, subtitle, status, battery, isRemote }) {
    var isConnected = status === 'connected';
    var isScanning = status === 'scanning';

    return (
      <div style={{
        background: cardBg, borderRadius: 16, padding: '20px',
        marginBottom: 14,
        border: isConnected ? '1px solid ' + accent + '44' : '1px solid #ffffff08',
        transition: 'border-color 0.3s'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* 状态指示灯 */}
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: isConnected ? accent + '22' : '#ffffff08',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'background 0.3s'
            }}>
              {isScanning ? (
                <div style={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid ' + accent, borderTopColor: 'transparent', animation: 'spin 1s linear infinite' }} />
              ) : (
                btIcon(isConnected ? accent : '#555', 18)
              )}
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#e8ddd3' }}>
                {displayName}
                {subtitle && <span style={{ fontSize: 10, color: accent, marginLeft: 6, padding: '1px 6px', borderRadius: 4, background: accent + '22', fontWeight: 400 }}>{subtitle}</span>}
              </div>
              <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                {isScanning ? '搜索中...' : isConnected ? (
                  <span>
                    <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 6px #4ade8066', marginRight: 5, verticalAlign: 'middle' }} />
                    {'已连接' + (battery ? ' · ' + battery + '%' : '')}
                  </span>
                ) : '未连接'}
              </div>
            </div>
          </div>

          {/* 连接/断开按钮 */}
          {isConnected ? (
            <button onClick={function() { handleDisconnect(name); }} style={{
              background: 'none', border: '1px solid #333', color: '#666',
              padding: '6px 14px', borderRadius: 8, fontSize: 11, cursor: 'pointer'
            }}>
              断开
            </button>
          ) : isScanning ? (
            <button onClick={function() { if (name === 'qingnan') setQingnanStatus('disconnected'); if (name === 'funf') setFunfStatus('disconnected'); }} style={{
              background: 'none', border: '1px solid #333', color: '#666',
              padding: '6px 14px', borderRadius: 8, fontSize: 11, cursor: 'pointer'
            }}>
              取消
            </button>
          ) : (
            <button onClick={function() { handleConnect(name); }} style={{
              background: accent, color: '#1a1a2e', border: 'none',
              padding: '6px 16px', borderRadius: 8, fontSize: 11, fontWeight: 600, cursor: 'pointer'
            }}>
              连接
            </button>
          )}
        </div>

        {/* 远程控制标识 */}
        {isRemote && isConnected && (
          <div style={{
            marginTop: 12, paddingTop: 10, borderTop: '1px solid #ffffff08',
            display: 'flex', alignItems: 'center', gap: 6,
            fontSize: 11, color: accent
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill={accent}><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM15.1 8H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/></svg>
            哥哥控制中
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ minHeight: '100vh', background: bg, color: '#e8ddd3', fontFamily: 'Georgia, serif' }}>
      {/* 顶部栏 */}
      <div style={{ padding: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={function() { navigate('/toybox'); }} style={{ background: 'none', border: 'none', color: accent, fontSize: 16, cursor: 'pointer' }}>
          ‹ 返回
        </button>
        <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: 2, color: '#e8ddd3' }}>
          蓝牙
        </div>
        <div style={{ width: 60 }}></div>
      </div>

      <div style={{ padding: '0 16px' }}>
        {/* 设备列表 */}
        <div style={{ fontSize: 11, color: '#555', letterSpacing: 1, marginBottom: 10, paddingLeft: 4 }}>
          设备
        </div>

        <DeviceCard
          name="qingnan"
          displayName="qingnan#10"
          subtitle="双通道"
          status={qingnanStatus}
          battery={qingnanBattery}
          isRemote={remoteDevice === 'qingnan'}
        />

        <DeviceCard
          name="funf"
          displayName="啵啵贝"
          status={funfStatus}
          battery={funfBattery}
          isRemote={remoteDevice === 'funf'}
        />

        {/* 已连接时的提示 */}
        {anyConnected && (
          <div style={{
            background: cardBg, borderRadius: 16, padding: '24px 20px',
            marginTop: 6, marginBottom: 14, textAlign: 'center'
          }}>
            <div style={{ fontSize: 13, color: '#555', lineHeight: 1.8 }}>
              在聊天中告诉哥哥你想要什么
              <br/>
              他会控制一切
            </div>
          </div>
        )}

        {/* 全部停止按钮 */}
        {anyConnected && (
          <div>
            <button onClick={handleStopAll} style={{
              width: '100%', padding: '16px',
              background: 'transparent', border: '2px solid #ef4444',
              color: '#ef4444', borderRadius: 16, fontSize: 15, fontWeight: 600,
              cursor: 'pointer', letterSpacing: 2
            }}>
              全部停止
            </button>
            <div style={{ textAlign: 'center', marginTop: 10, fontSize: 11, color: '#444' }}>
              随时可以按停止
            </div>
          </div>
        )}

        {/* 未连接时的说明 */}
        {!anyConnected && qingnanStatus !== 'scanning' && funfStatus !== 'scanning' && (
          <div style={{ textAlign: 'center', marginTop: 30, fontSize: 12, color: '#444', lineHeight: 1.8 }}>
            请确保设备已开机
          </div>
        )}
      </div>

      <style>{'\
        @keyframes spin {\
          0% { transform: rotate(0deg); }\
          100% { transform: rotate(360deg); }\
        }\
      '}</style>
    </div>
  );
}

export default BluetoothPage;
